import { render, staticRenderFns } from "./DeliverySvg.vue?vue&type=template&id=b9dcf844&"
import script from "./DeliverySvg.vue?vue&type=script&lang=js&"
export * from "./DeliverySvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports